import { render, staticRenderFns } from "./APaises.vue?vue&type=template&id=48517a90"
import script from "./APaises.vue?vue&type=script&lang=js"
export * from "./APaises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports